import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaFacebookMessenger, FaMobileAlt } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { HiOutlineMail } from 'react-icons/hi';
import { ImFacebook2, ImLocation } from 'react-icons/im';

export const themeMood = [
    {
        cursor: {
            color: {
                first: '255,137,58' // Brown
            }
        },
        color: {
            first: '#FF893A',    // Brown
            second: '#ff893a57', // Litw Brown
            third: '#012d3dd1',    // Lite Blue
            fourth: '#CCCCCC',    // Lite White
            fifth: 'Black',
            sixth: 'white',
            gray: 'Gray',
        },
        font: {
            first: "'Montserrat', sans-serif",
            second: "'Poppins', sans-serif",
        }
    },
    {
        cursor: {
            color: {
                first: '73, 53, 64' // Brown
            }
        },
        color: {
            first: '#493540',    // Brown
            second: '#949494', // Litw Brown
            third: '#79B4B7',    // Lite Blue
            fourth: '#1A1A40',    // Lite White
            fifth: '#DFD3C3',
            sixth: '#041C32',
            gray: '#969696',
        },
        font: {
            first: "'Montserrat', sans-serif",
            second: "'Poppins', sans-serif",
        }
    },
    
]
export const profilesLinksData = [
    {
        name: 'Email',
        icon: <HiOutlineMail />,
        link: 'https://ahnabshahin@gmail.com',
        value: 'ahnabshahin@gmail.com',
    },
    {
        name: 'Phone',
        icon: <FaMobileAlt />,
        link: '+8801942565009',
        value: '+880 194 256 5009',
    },
    {
        name: 'GitHub',
        icon: <BsGithub />,
        link: 'https://github.com/AhnabShahin',
        value: 'github.com/ AhnabShahin',
    },
    {
        name: 'linkedin',
        icon: <BsLinkedin />,
        link: 'https://www.linkedin.com/in/ahnab-shahin/',
        value: 'linkedin.com/in/ ahnab-shahin',
    },
    {
        name: 'location',
        icon: <ImLocation />,
        link: 'https://goo.gl/maps/xQPtwbfTeuXa1yaH7',
        value: 'Jalkury Godenail Narayanganj',
    },
    {
        name: 'Facebook',
        icon: <ImFacebook2 />,
        link: 'https://www.facebook.com/ahnabshahin',
        value: 'facebook.com/ ahnabshahin',
    },
    {
        name: 'Messenger',
        icon: <FaFacebookMessenger />,
        link: 'https://www.messenger.com/ahnabshahin',
        value: 'messenger.com/ ahnabshahin',
    },
    {
        name: 'Instagram',
        icon: <GrInstagram />,
        link: 'https://www.instagram.com/ahnab.shahin/',
        value: 'instagram.com/ ahnab.shahin',
    },
]
export const projectsData = [
    {
        name: 'Bangladesh General Insurance Company',
        image: 'images/BGIC.png',
        github: 'https://github.com/AhnabShahin',
        live: 'http://bgicinsure.com/',
    },
    {
        name: 'Bee Keeping',
        image: 'images/Bee-Keeping.png',
        github: 'https://themeforest.net/checkout/84137739/create_account',
        live: 'https://preview.themeforest.net/item/annahl-beekeeping-and-honey-shop-react-template/full_screen_preview/35410055',
    },
    {
        name: 'Portfar Personal Portfolio',
        image: 'images/portfar-personal-portfolio.png',
        github: 'https://themeforest.net/checkout/84132199/',
        live: 'https://preview.themeforest.net/item/portfar-personal-portfolio-nextjs-template/full_screen_preview/35278934',
    },
    {
        name: 'Custard Cake',
        image: 'images/custard-cake.png',
        github: 'https://github.com/AhnabShahin/Custard-Cake-Client-Side',
        live: 'https://custard-cake.web.app/',
    },
    {
        name: 'Medical Services',
        image: 'images/medical-service.png',
        github: 'https://github.com/AhnabShahin/Health-care',
        live: 'https://eloquent-bohr-b02e52.netlify.app/',
    },
    {
        name: 'Tourism',
        image: 'images/tourism.png',
        github: 'https://github.com/AhnabShahin/Tourism-client-side',
        live: 'https://tourism-23.web.app/',
    },
    {
        name: 'Assault Rifles',
        image: 'images/assault-rifles.png',
        github: 'https://github.com/AhnabShahin/Assault-Rifles-client-side',
        live: 'https://assault-rifles.web.app/',
    },
    {
        name: 'Emotion Monitoring',
        image: 'images/emotion-monitoring.png',
        github: 'https://github.com/AhnabShahin/Emotion-monitoring',
        live: '#',
    },
    {
        name: 'Portfolio',
        image: 'images/portfolio.png',
        github: 'https://github.com/AhnabShahin/AhnabShahin',
        live: 'https://ahnabshahin.github.io/',
    },
    {
        name: 'larevel curd api with jwt',
        image: 'images/larevel-curd-api-with-jwt.png',
        github: 'https://github.com/AhnabShahin/Larevel-CURD-api-with-JWT',
        live: 'https://larevel-curd-api-with-jwt.netlify.app/',
    },
    {
        name: 'BCCG ospital',
        image: 'images/bccg-hospital.png',
        github: 'https://bccghospital.com/',
        live: 'https://bccghospital.com/',
    },
]
export const personalInformationData = {
    image: 'https://ahnabshahin.github.io/assets/images/Image.jpg',
    name: 'Shahin Alam',
    title: 'Web Developer',
    details: 'I am a highly competent IT professional with a proven track record in designing websites, networking and managing databases. I have strong technical skills as well as excellent interpersonal skills, enabling me to interact with a wide range of clients. I am eager to be challenged in order to grow and further improve my IT skills. My greatest passion is in life is using my technical know-how to benefit other people and organisations.',
    liveProjects: 13,
    githubCommits: 377,
    experience: 1.5,
}
export const skillData = [
    {
        subject: 'HTML',
        A: 99,
    },
    {
        subject: 'CSS',
        A: 90,
    },
    {
        subject: 'JS',
        A: 95,
    },
    {
        subject: 'React',
        A: 80,
    },
    {
        subject: 'PHP',
        A: 70,
    },
    {
        subject: 'Laravel',
        A: 65,
    },
];
export const goalData = [
    {
        name: 'Design',
        Percent: 60,
    },
    {
        name: 'Front End',
        Percent: 90,
    },
    {
        name: 'API',
        Percent: 70,
    },
    {
        name: 'Back End',
        Percent: 80,
    },
];
export const educationData = [
    {
        head: 'University of asia pacific',
        bold: '',
        body: 'B.Sc. in Computer Science and Engineering',
        from: '2017',
        to: '2021',
        tag: 'undergraduate',
    },
    {
        head: 'Government laboratory high and college',
        bold: '',
        body: 'Higher Secondary Certificate',
        from: '2015',
        to: '2016',
        tag: 'Science',
    },
    {
        head: 'Tejgaon govt high school',
        bold: '',
        body: 'Secondary School Certificate',
        from: '2003',
        to: '2014',
        tag: 'Science',
    },
]
export const experienceData = [
    {
        head: 'Web Developer',
        bold: 'Confidence Software Limited',
        body: 'Develop responsive websites and powerful complete management and accounting software for clients like insurance, hospital, educational organizations',
        from: 'Feb 2022',
        to: 'Now',
        tag: 'Running',
    },
    {
        head: 'React JS Instructor',
        bold: 'eShikhon.com',
        body: 'eShikhon popular for Online Live Training On Freelancing Training Courses, Computer IT Training Courses, Skill Development Courses and Career Development. Recently i joined here to share my little knowledge among the students.',
        from: 'Feb 2022',
        to: 'Now',
        tag: 'Part Time',
    },
    {
        head: 'Freelancer',
        bold: 'Themeforest',
        body: 'As a part time freelance I worked there',
        from: 'Jun 2021',
        to: 'Now',
        tag: 'Contributor',
    },
    {
        head: 'Web Developer',
        bold: 'MicromaxSoft',
        body: 'Micromaxsoft is one of the most professional and reputed IT company in Bangladesh. It was established in 2008 with the vision to make Digital Bangladesh. They provide all kinds of IT related services.',
        from: 'Dec 2020',
        to: 'Aug 2021',
        tag: 'Last One',
    },
]
export const volunteeringData = [
    {
        head: 'National it competition for youth with disabilities 2019',
        bold: '',
        body: 'volunteer of two-day long ACM-International Collegiate programming Contest (ACM-ICPC)',
        from: '2019',
        to: '',
        tag: '',
    },
    {
        head: 'INTER SCHOOL AND COLLAGE PROGRAMMING CONTEST 2019',
        bold: '',
        body: 'Volunteer of organizer team where chief guest was BUET professor Mohammad Kaikobad',
        from: '2019',
        to: '',
        tag: '',
    },
    {
        head: 'ICPC - INTERNATIONAL COLLEGIATE PROGRAMMING CONTEST 2017',
        bold: '',
        body: 'Volunteer of NITCYD-19. The daylong IT competition for differently-abled students was held at the University of Asia pacific (UAP). Chief Guest: Mr. Junaid Ahmed Palak MP, Honorable State Minister, ICT Division.',
        from: '2017',
        to: '',
        tag: '',
    },
    {
        head: 'PRESIDENT OF UAP CSE SPORTS CLUB',
        bold: '',
        body: 'Spring - 2021',
        from: '2021',
        to: '',
        tag: '',
    },
]